<h2 class="mat-h2">Uploads</h2>
<input type="file" (change)="uploadFile($event)" class="file-input" #fileUpload>
<button mat-stroked-button (click)="fileUpload.click()" class="upload-button">
  <mat-icon *ngIf="!(uploadingFile$ | async)">attach_file</mat-icon>
  <mat-spinner diameter="20" *ngIf="(uploadingFile$ | async)"></mat-spinner>
  Upload file
</button>
<mat-table [dataSource]="files$ | async">
  <ng-container matColumnDef="url">
    <mat-header-cell *matHeaderCellDef> preview</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <img [alt]="row.name" height="50" [src]="row.url"/>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef> name</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.name }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> actions</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <button mat-stroked-button [cdkCopyToClipboard]="row.url">
        <mat-icon>content_copy</mat-icon>
        Copy URL
      </button>
      <button mat-stroked-button (click)="deleteFile(row)">
        <mat-icon>delete</mat-icon>
        Delete
      </button>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: columns"></mat-row>
</mat-table>
